import React from 'react';
import PropTypes from 'prop-types';
import { TwitterPicker } from 'react-color';
import { Field } from 'redux-form';
import Icon, { GLYPHS } from '../../../common/icon';

const onChangeContainer = onChange => color => onChange(color.hex);
const normalize = value => (value ? value.replace(/^.{1}/g, '0x') : null);
const format = value => (value ? value.replace(/^.{2}/g, '#') : null);
const colorPicker = field => (
  <div className="u-position-relative">
    <button
      type="button"
      className="c-color-picker__button"
      style={{
        backgroundColor: field.input.value,
      }}
      onClick={field.toggle}
    >
      { !field.input.value && (<Icon glyph={GLYPHS.edit} size="medium" />)}
    </button>
    { field.isOn && (
      <div
        className="u-position-relative u-color-picker"
      >
        <TwitterPicker
          color={field.input.value || '#000'}
          onChange={onChangeContainer(field.input.onChange)}
        />
      </div>
    ) }
  </div>
);
const ColorPickerField = props => (
  <div className={props.wrapperClass}>
    <div className="c-label-new">{ props.label }</div>
    <Field
      normalize={normalize}
      format={format}
      component={colorPicker}
      {...props}
    />
  </div>
);

ColorPickerField.propTypes = {
  label: PropTypes.string,
  wrapperClass: PropTypes.string,
};
ColorPickerField.defaultProps = {
  label: 'Color Picker',
  wrapperClass: 'layout__item u-1/2-medium-and-up',
};
export default ColorPickerField;
